export const ENVIRONMENT_GLOBAL = {
  envName: '',
  production: false,
  loggingEnabled: true,
  appVersion: require('../../package.json').version,
  redirect: {
    host: '',
    route: '/oauth'
  },
  auth_L1: {
    client_id: 'serviceportal',
    scope: 'phone email profile openid',
    endpoint: {
      host: '',
      paths: {
        prefix: '/auth/realms/Securicloud',
        account: '/account',
        login: '/protocol/openid-connect/auth',
        token: '/protocol/openid-connect/token',
        certs: '/protocol/openid-connect/certs',
        logout: '/protocol/openid-connect/logout',
        register: '/protocol/openid-connect/registrations'
      }
    }
  },
  backend: {
    scope: 'ssc',
    client_id: '',
    endpoint: {
      host: '',
      paths: {
        prefix: '/api',
        token: '/auth/token',
        logout: '/auth/logout'
      }
    },
    wsEndpoint: '',
    wsHeartbeatIntervalMs: 20000
  },
  links: {
    help: 'https://www.meinhplus.de/lernen/faq-haeufig-gestellte-fragen',
    applications: {
      mh2: {
        paths: {
          service: '/pages/mgmt',
          products: '/pages/product-knowledge/catalogs/d77f7058-072c-4eeb-ad1b-14bd1829b13b/products',
          downloads: '/pages/product-knowledge/downloads'
        }
      },
      l2: {
        host: '',
        domains: '/multi-domain-mgmt'
      },
      oms: {
        host: ''
      },
      go: {
        host: ''
      },
      hpo: {
        host: ''
      },
      b2b: {
        host: ''
      },
      dongle: {
        host: ''
      },
      dongle_admin: {
        host: ''
      },
      learn_world: {
        host: ''
      },
      elec_calc_tool: 'https://www.hekatron-planungstools.de/stromberechnung.php',
      tender_tool_extend: 'https://www.hekatron-planungstools.de/Extend.php',
      remote_admin: 'https://remote.meinhplus.de/admin',
      remote_desktop: 'https://remote.meinhplus.de/iac20desktop/',
      status: 'https://h.meinhplus.de/hplus-status-ihr-brandschutz-plus-fuer-aufschaltung',
      ai_plan: 'https://plan.meinhplus.de'

    },
    support: {
      host: 'https://www.meinhplus.de',
      paths: {
        knowledge: '/lernen',
        steps: '/ihre-schnellanleitung',
        faq: '/faq-haeufig-gestellte-fragen'
      }
    },
    avendoo_learning: 'https://hekatron.avendoo.de/l/openid/oidc?sso=hplusnuggets',
    productboard: {
      host: 'https://portal.productboard.com/vb1kntfwmt73prxkmezve7ju?token=',
      privacy: 'https://www.productboard.com/privacy-policy/'
    }
  },
  imprint: {
    endpoint: {
      paths: {
        imprint: '/impressum'
      }
    }
  },
  domains: {
    endpoint: {
      paths: {
        prefix: '/api/domains',
        profile: '/profile'
      }
    }
  },
  users: {
    endpoint: {
      paths: {
        prefix: '/api/users',
        profile: '/profile',
        applications: '/applications',
        onboardingCompleted: '/onboarding-completed'
      }
    }
  },
  domaindata: {
    endpoint: {
      paths: {
        prefix: '/api/domain',
        companydata: '/companydata'
      }
    }
  },
  productboard:{
    endpoint: {
      paths: {
        prefix: '/api/productboard',
        token: '/token'
      }
    }
  }
};
